// 角色数据配置文件
// PC端和移动端共用的角色基础数据

const baseCharacterData = [
  // {
  //   id: 1,
  //   names: ["/img/pc/name2_1.png", "/img/pc/name2_2.png"],
  //   descriptions: [
  //     [
  //       "忘却自己的姓名和过往，苏醒于废墟遗迹中的「归还者」。<br />遗忘并未抹消你与那名少女的契约。",
  //       "为了追寻故乡和过往，为了阻止终末蚀潮，你们将再次踏上旅途。<br />违抗忘却、超越时间。",
  //     ],
  //     [
  //       "因被契约者遗忘而陷于眠昧的虚弱少女。<br />时隔许久再次苏醒，是为替你挡下致命一击。",
  //       "「恢复契约的关键是——想起她的名字。」<br />那之后，记忆碎片纷至沓来。<br />她坚信你们会如预言所说那般，令世界恢复原初。",
  //     ],
  //   ],
  //   iconImages: ["/img/pc/sol_icon2.png", "/img/pc/sl_icon2.png"],
  // },
  // {
  //   id: 2,
  //   names: ["/img/pc/name1_1.png", "/img/pc/name1_2.png"],
  //   descriptions: [
  //     [
  //       "忘却自己的姓名和过往，苏醒于废墟遗迹中的「归还者」。<br />遗忘并未抹消你与那名少女的契约。",
  //       "为了追寻故乡和过往，为了阻止终末蚀潮，你们将再次踏上旅途。<br />违抗忘却、超越时间。",
  //     ],
  //     [
  //       "因被契约者遗忘而陷于眠昧的虚弱少女。<br />时隔许久再次苏醒，是为替你挡下致命一击。",
  //       "「恢复契约的关键是——想起她的名字。」<br />那之后，记忆碎片纷至沓来。<br />她坚信你们会如预言所说那般，令世界恢复原初。",
  //     ],
  //   ],
  //   iconImages: ["/img/pc/sol_icon1.png", "/img/pc/sl_icon1.png"],
  // },
  {
    id: 4,
    role: "pata",
    names: ["/img/pc/name4_1.png", "/img/pc/name4_2.png"],
    descriptions: [
      [
        "洛伦最年轻的猎宝团团长——帕塔。<br />以寻宝为首要目标的金羊毛猎团，虽然成员常年只有她自己，虽然每天都在为筹措「寻宝基金」做各种奇怪委托，但团长大人确实有在践行自己订下的团训：<br />「要一路朝着宝藏狂奔，也要骄傲地回望我们一路创造的宝藏！」",
        "正是这颗诚挚的冒险者之心，使遥远之国那居于殿堂中的灵自漫长眠昧中苏醒。<br />金色眼瞳投下瞥视，新的契约就此订立。",
      ],
      [
        "金羊毛诞生于人类对「梦想与真理」的渴求。<br />于黄金之国的殿堂中苏醒，它赐予盲眼少年双目，跟随他一路冒险，直到传奇终结之日。<br />「我曾高居殿堂之上，倾听人类的百般心愿，为其在弥蒙之中指引方向。<br />我也曾跟随冒险者一路流离，亲眼见证故事的起落。」",
        "女孩手捧藏宝图，以热烈的决心许下心愿：无穷无尽的冒险之路。<br />新的篇章就此展开。",
      ],
    ],
    iconImages: ["/img/pc/sol_icon4.png", "/img/pc/sl_icon4.png"],
  },
  {
    id: 5,
    role: "enluoer",
    names: ["/img/pc/name5_1.png", "/img/pc/name5_2.png"],
    descriptions: [
      [
        "「以规则和公正，才能为洛伦建立新的秩序……」他深知这一点。<br />纵使他要所坚信的正义和他的出身一样，都会让他付出巨大的代价。<br />他也从未放弃过反抗。",
        "结契也没能让影犬低下它高昂的头颅。<br />恩洛尔用身躯示以证明。<br />「——来吧，你就来尝尝看，我的决心。」",
      ],
      [
        "它是王室灵体中的异类——反叛与抗争的化身，也是战争与牺牲滋养出的灵体，天地间再没有比其更尖利的牙齿。<br />然而，这次颂出它的，却是一个已经脱离洛伦王室的年轻人。<br />我也曾跟随冒险者一路流离，亲眼见证故事的起落。」",
        "这青年究竟是王室之耻，还是劈开这残破混乱的旧居的利剑？<br />角逐、缠斗、在暗影与剑影交映的火光电石之间，影犬瞥见了——那执着反抗者的不屈眼神。",
      ],
    ],
    iconImages: ["/img/pc/sol_icon5.png", "/img/pc/sl_icon5.png"],
  },
  {
    id: 3,
    role: "annata",
    names: ["/img/pc/name3_1.png", "/img/pc/name3_2.png"],
    descriptions: [
      [
        "被称为「天才少女」的皇家学会成员。<br />曾是一文不名的落难贵族后裔，却破格通过入学测验，甚至被学会会长选为助手。<br />图书馆、绝对精确的时间表和「答案」，构成了她生活的全部。",
        "知性派理想陨落之后，几乎无人再将「真理」作为最高理想。她却毫不畏惧地向着黑暗根基的深处呼唤未知。<br />于是，深渊向她发出回响。",
      ],
      [
        "可知论之灵。她是万物有序的理想主义的化身，理性法则的主宰。<br />随着蚀灾、战争、秩序和信仰的失落，世界的非理性和荒诞无常，使可知论沦为永眠之盏。<br />写有她赞歌和真律的典籍被抛入火炉。数百年间，无人再敢提起她的姓名。",
        "直到一句似曾相识的微弱呼唤，从遥远不知处传来——<br />「我想知道万事万物的名字……和所有的'答案'。」",
      ],
    ],
    iconImages: ["/img/pc/sol_icon3.png", "/img/pc/sl_icon3.png"],
  },
];

// PC端角色数据配置
export const pcCharacterData = baseCharacterData.map((character) => ({
  ...character,
  image: `/img/pc/rw${character.id}.png`,
}));

// 移动端角色数据配置
export const mobileCharacterData = baseCharacterData.map((character) => ({
  ...character,
  image: `/img/m/rw${character.id}.png`,
  showTxtStates: [false, false], // 移动端特有的文本展开状态
}));

// 角色数据工具函数
export const getCharacterById = (characterList, id) => {
  return characterList.find((character) => character.id === id);
};

export const getActiveCharacter = (characterList, index) => {
  return characterList[index];
};
